import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { AssignSeatData, CreateInvoiceData, DeleteSeatData, TDataToken, TQueries } from "./type";


const createInvoice = (
  data: TDataToken,
  payload: CreateInvoiceData
) => {
  return $api
    .post("/admin/invoices", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateInvoice = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, CreateInvoiceData>
) => {
  return useMutation({
    mutationFn: (payload:CreateInvoiceData) =>
        createInvoice(data, payload),
    ...config
  });
};

const getInvoices = (
    data: TDataToken,
    payload: TQueries
) => {
    return $api
        .get("/admin/invoices", { token: data.accessToken, params: { ...payload } })
        .then((response) => {
            return response;
        });
};

export const useGetInvoices = (data: TDataToken, queries: TQueries, config?: {}) => {
    return useQuery({
        queryKey: ["get-invoices", queries],
        queryFn: () => getInvoices(data, queries),
        ...config as UseQueryOptions<any>
    });
};

const assignSeat = (
  data: TDataToken,
  payload: AssignSeatData
) => {
  return $api
    .post("/admin/licenses/assign-seats", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useAssignSeat = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, AssignSeatData>
) => {
  return useMutation({
    mutationFn: (payload:AssignSeatData) =>
      assignSeat(data, payload),
    ...config
  });
};


const deleteSeat = (
  data: TDataToken,
  payload: DeleteSeatData
) => {
  return $api
    .post("/admin/licenses/delete-seats", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useDeleteSeat = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, DeleteSeatData>
) => {
  return useMutation({
    mutationFn: (payload:DeleteSeatData) =>
      deleteSeat(data, payload),
    ...config
  });
};

const extendSeat = (
  data: TDataToken,
  payload: DeleteSeatData
) => {
  return $api
    .put("/admin/licenses/extend-seats", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateSeat = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, DeleteSeatData>
) => {
  return useMutation({
    mutationFn: (payload:DeleteSeatData) =>
      extendSeat(data, payload),
    ...config
  });
};